import { BaseDataModel } from "./base";

export class Branch extends BaseDataModel {
	name!: string;
	labAccountNumber!: string;
	salespersonIds!: string[];
	externalLocationId?: string[];
}
